/**
 * @generated SignedSource<<3c64310e18fecabc9223543d23c1d2c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBlurbRareFind_item$data = {
  readonly pricingGuidance: {
    readonly rareFind: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPricingGuidanceCopy_item">;
  readonly " $fragmentType": "PdpSharedBlurbRareFind_item";
};
export type PdpSharedBlurbRareFind_item$key = {
  readonly " $data"?: PdpSharedBlurbRareFind_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBlurbRareFind_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBlurbRareFind_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPricingGuidanceCopy_item"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PricingGuidance",
      "kind": "LinkedField",
      "name": "pricingGuidance",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rareFind",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "f816d0f0b4dc79a7b797a1b45bfa0281";

export default node;
